export const normalizeUserRoles = (roleValue) =>
  (Array.isArray(roleValue) ? roleValue : [roleValue])
    .filter(Boolean)
    .map((role) => String(role).trim().toLowerCase());

export const hasUserRole = (roleValue, targetRole) =>
  normalizeUserRoles(roleValue).includes(String(targetRole || "").trim().toLowerCase());

export const isSameCompanyUser = (user, companyId) =>
  String(user?.companyId || "") === String(companyId || "") ||
  String(user?.id || "") === String(companyId || "");

export const isActiveUser = (user) =>
  Boolean(user) && user?.deleted !== true && user?.status === true;

export const isEmployeeTeamAdminSeat = (user) =>
  hasUserRole(user?.role, "Employee") &&
  String(user?.employeerole || "").trim().toLowerCase() === "admin";

export const isCompanyManagerTeamAdminSeat = (user) =>
  hasUserRole(user?.role, "companyUser") && user?.teamAdminSeat === true;

export const isRestrictedCompanyManager = (user) =>
  hasUserRole(user?.role, "companyUser") && !isCompanyManagerTeamAdminSeat(user);

export const RESTRICTED_COMPANY_MANAGER_BLOCKED_PREFIXES = [
  "/operations",
  "/supplies",
  "/reports",
  "/communications/message-board/manage-channel",
  "/communications/message-board/create-channel",
  "/communications/notifications",
];

export const isRestrictedCompanyManagerBlockedPath = (path) => {
  const routePath = String(path || "");
  return RESTRICTED_COMPANY_MANAGER_BLOCKED_PREFIXES.some(
    (prefix) => routePath === prefix || routePath.startsWith(prefix)
  );
};

export const isTeamAdminSeatUser = (user) =>
  isActiveUser(user) &&
  (isEmployeeTeamAdminSeat(user) || isCompanyManagerTeamAdminSeat(user));

export const companyHasActiveTeamAdminSeat = (users = [], companyId) =>
  (users || []).some((user) => isSameCompanyUser(user, companyId) && isTeamAdminSeatUser(user));

export const getEffectiveUserRolesForAccess = (user) => {
  const rawRoles = Array.isArray(user?.role) ? [...user.role] : user?.role ? [user.role] : [];
  const roles = rawRoles
    .map((role) => (role === "Employee" && user?.employeerole ? user.employeerole : role))
    .filter(Boolean);

  if (isCompanyManagerTeamAdminSeat(user)) {
    roles.push("admin");
  }

  if (isRestrictedCompanyManager(user)) {
    const companyUserIndex = roles.findIndex(
      (role) => String(role || "").toLowerCase() === "companyuser"
    );
    if (companyUserIndex >= 0) roles.splice(companyUserIndex, 1);
    roles.push("admin");
  }

  return [...new Set(roles)];
};
